module.exports = __webpack_public_path__ + "img/miniweb_stylewave_head_v01.5b8fd5c5.png";